import theme from '../../../lib/theme';
import { ButtonProps } from './Button';

const {
  corners,
  scale,
  layouts,
  colors,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default ({
  brand = 'sas',
  color = 'primary',
  inverted,
  block,
}: ButtonProps) => ({
  container: {
    ...layouts.row,

    justifyContent: 'center',
    cursor: 'pointer',
    color: inverted
      ? colors[brand][color] || colors[color]
      : colors[brand].button.color,
    backgroundColor: inverted ? colors.white : colors[brand].button.background,
    border: `2px solid ${
      inverted ? colors[brand][color] || colors[color] : 'transparent'
    }`,
    outline: 'none',
    borderRadius: corners.f,
    fontFamily: families.primary,
    fontWeight: font.bold,
    fontSize: font.m,
    lineHeight: heights.m,
    letterSpacing: spacings.m,
    padding: `10px 30px !important`,
    transition: 'all 150ms linear',
    textDecoration: 'none !important',
    textAlign: 'center',
    width: block ? '100%' : 'auto',

    '&:hover': {
      color: `${colors[brand].button.hover_color} !important`,
      backgroundColor: `${colors[brand].button.hover_background} !important`,
      borderColor: `${colors[brand].button.hover_background} !important`,
    },

    '&:disabled': {
      cursor: 'not-allowed',
      backgroundColor: colors.grey,
    },
  },
});
